export default {
  GET_JOB_DOCUMENTS: (state) => {
    return state.documents;
  },
};
